<span class="c-field-value" *ngIf="languages[data]">
  <ng-container *ngIf="languages[data].name !== 'All Languages'; else allLanguages">
    <img class="c-field-value__icon" *ngIf="languages[data].img" src="{{ languages[data].img }}" width="20" height="20" />
    <span class="c-field-value__text" *ngIf="type === 'default'"
      >{{ data | uppercase }}
      <span class="c-field-value__text -gray"><span class="c-field-value__deliver">/</span>{{ languages[data].name }}</span></span
    >
    <span *ngIf="type === 'short'">&nbsp;&nbsp;{{ languages[data].name }}</span>
  </ng-container>
</span>
<gtd-ui-field-default-string-or-empty *ngIf="!languages[data]" [data]="data"></gtd-ui-field-default-string-or-empty>

<ng-template #allLanguages>
  <img src="/assets/new-img/flags/all.svg" width="32" height="16" class="mr-8" />
  <span class="text-color text-color--gray" i18n="@@common.all_languages">All Languages</span>
</ng-template>
